import React from 'react';

import './WorkflowMessagePanel.css';

/**
 * @param {object} props
 * @param {string} [props.mainHtml]
 * @param {string[]} [props.extraMessages]
 * @param {React.ReactNode} [props.actions]
 */
const WorkflowMessagePanel = ({ mainHtml, extraMessages = [], actions }) => {
    const has_main = Boolean(mainHtml && String(mainHtml).trim());
    const extras = (extraMessages || []).filter((m) => m && String(m).trim());

    if (!has_main && extras.length === 0 && !actions)
        return null;

    return (
        <div className="WorkflowMessagePanel" role="status">
            {has_main && (
                <div
                    className="WorkflowMessagePanel__body"
                    dangerouslySetInnerHTML={{ __html: mainHtml }}
                />
            )}
            {extras.map((message, index) => (
                <div
                    key={index}
                    className="WorkflowMessagePanel__extra"
                    dangerouslySetInnerHTML={{ __html: message }}
                />
            ))}
            {actions && (
                <div className="WorkflowMessagePanel__actions">
                    {actions}
                </div>
            )}
        </div>
    );
};

export default WorkflowMessagePanel;
